import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { NextCoachingService } from '../../../../../coaching-base/coaching.service';
import { ObservationEntity } from '../../../../../coaching-base/config';
import { LookupBox } from '../../../../../coaching-base/general';
import { TranscriptService as CoachingTranscriptService } from '../../../../../coaching-base/transcript.service';
import { ObservationService } from '../../../../../coaching-observation/observation/observation.service';
import { Dependencies } from '../../../../../store';
import { PayloadAction } from '../../../../../store.model';
import { TranscriptSummaryView } from '../model/transcript-summary-view.model';
import { ActionType } from '../transcript-summary.action';
import { transcriptsSummaryTransformer } from '../transformer/transcripts-summary.transformer';

import { Reload, reloadResult } from './reload.action';

export const reloadEpic = (
    action: ActionsObservable<PayloadAction<ActionType, Reload>>,
    _: StateObservable<any>,
    deps: Dependencies,
): Observable<ActionType> =>
    action.pipe(
        ofType(ActionType.COACHING_DETAIL__TS__RELOAD),
        switchMap((act) => {
            const coachingService =
                deps.injector.get<NextCoachingService>(NextCoachingService);
            const observationService =
                deps.injector.get<ObservationService>(ObservationService);
            const ctsService = deps.injector.get<CoachingTranscriptService>(
                CoachingTranscriptService,
            );

            return forkJoin([
                of(null).pipe(coachingService.retrieveLookupBox()),
                ctsService.retrieveSummary(act.payload.parameters),
                of(null).pipe(observationService.retrieveObservationConfig()),
            ]).pipe(
                map((ret) => {
                    return [
                        ret[0],
                        transcriptsSummaryTransformer(
                            ret[1],
                            ret[0].behaviours,
                            ret[0].subBehaviours,
                        ),
                        ret[2],
                    ] as [LookupBox, TranscriptSummaryView, ObservationEntity];
                }),
                map(
                    (
                        ret: [
                            LookupBox,
                            TranscriptSummaryView,
                            ObservationEntity,
                        ],
                    ) => {
                        return reloadResult(
                            {
                                ...act.payload,
                                return: ret[1],
                                observationConfig: ret[2],
                            },
                            act.storePath,
                        );
                    },
                ),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
